// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/.pnpm/css-loader@6.11.0_@rspack+core@0.7.5_webpack@5.99.9_@swc+core@1.12.4_/node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/.pnpm/css-loader@6.11.0_@rspack+core@0.7.5_webpack@5.99.9_@swc+core@1.12.4_/node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `[data-order-by-button] {
    width: 150px;
    height: 35px;
}

.options-order-by {
    top: 100%;
    right: 0;
}

/* @media (width < 550px) {
    [data-order-by-button] {
        width: 100px !important;
        height: 45px !important;
    }
} */
`, "",{"version":3,"sources":["webpack://./../components/src/selects/OrderBySelectComponent/OrderBySelectComponent.css"],"names":[],"mappings":"AAAA;IACI,YAAY;IACZ,YAAY;AAChB;;AAEA;IACI,SAAS;IACT,QAAQ;AACZ;;AAEA;;;;;GAKG","sourcesContent":["[data-order-by-button] {\n    width: 150px;\n    height: 35px;\n}\n\n.options-order-by {\n    top: 100%;\n    right: 0;\n}\n\n/* @media (width < 550px) {\n    [data-order-by-button] {\n        width: 100px !important;\n        height: 45px !important;\n    }\n} */\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
